"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        class CanvasBase {
            constructor() { }
            init(readOnly) {
                if (readOnly)
                    return;
                designerv2.eventBus.subscribeToPropertyUpdates(payload => {
                    const componentId = payload.componentId;
                    const component = designerv2.designer.getComponent(componentId);
                    if (component) {
                        const element = $(`#${componentId}`);
                        if (element.length)
                            this.updateComponentElement(element, component);
                    }
                });
            }
            createComponentElement(component) {
                let $template = appn.utils.cloneTemplate(`component-${component.type}`, false);
                if ($template.length === 0)
                    $template = appn.utils.cloneTemplate('component-widget');
                $template.attr('id', component.id);
                this.onCreateComponentElement(component, $template);
                this.updateComponentElement($template, component);
                return $template;
            }
            updateComponentElement(element, component) {
                var _a, _b, _c, _d;
                if (component.title)
                    element.find('.componentTitle').text((_a = component.title) === null || _a === void 0 ? void 0 : _a.eng);
                const header = element.find('.componentLabel');
                if (component.label)
                    header.text((_b = component.label) === null || _b === void 0 ? void 0 : _b.eng);
                const hint = element.find('.componentHint');
                if (component.hint)
                    hint.text((_c = component.hint) === null || _c === void 0 ? void 0 : _c.eng);
                if (component.labelStyle)
                    this.applyFontStyle(header, component.labelStyle);
                if (component.hintStyle)
                    this.applyFontStyle(hint, component.hintStyle);
                if (component.bgColor)
                    element.find('.card').css('background-color', component.bgColor);
                const def = designerv2.componentManager.getDefinition(component.type);
                (_d = def === null || def === void 0 ? void 0 : def.render) === null || _d === void 0 ? void 0 : _d.call(def, element, component);
                this.onUpdateComponentElement(element, component);
                const hasPropertyError = $('.has-error[id^="prop-' + component.id + '-"]').length > 0;
                if (hasPropertyError) {
                    element.addClass('has-validation-error');
                }
            }
            applyFontStyle(element, style) {
                if (!element || element.length === 0)
                    return;
                element.css('color', style.color || '');
                const sizeMap = {
                    'Small': '0.6rem',
                    'Medium': '0.75rem',
                    'Large': '0.9rem'
                };
                element.css('font-size', sizeMap[style.size || 'Medium']);
                element.css('font-weight', style.decor === 'Bold' ? 'bold' : 'normal');
                element.css('font-style', style.decor === 'Italic' ? 'italic' : 'normal');
            }
        }
        designerv2.CanvasBase = CanvasBase;
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
